'use strict';

// Initialize required libraries
var dialog = require('../dialog');
var util = require('../util');
var ajax = require('../ajax');

// Initialize any constants
var PROMODETAILS_DIALOG_CLASSNAME = 'promotion-details-dialog';

/**
 * @function initializeLandingUIEvents
 * @description Initializes the UI events necessary to drive the landing page behavior
 */
function initializeLandingUIEvents() {
    // Handle clicks on the details link
    $('.pt_offerscoupons .oc-promo-details-link').on('click', function (e){
        e.preventDefault();

        // Initialize local variables
        var couponCode;
        var $contentAsset;
        var cid;

        // Derive the coupon-code from the promotional content display
        couponCode = getCouponCode(this);

        // Derive the content-assetId (so that we can display the content in the details display)
        $contentAsset = $(this).closest('.oc-offer-content');
        cid = $contentAsset.data('cid');

        // Render the promotion details modal using the coupon-code
        showPromotionDetailsModal(couponCode, cid);
    });

    // Handle clicks on the apply-promotions link
    $('.pt_offerscoupons .oc-apply-promo-link').on('click', function(e) {

        // If this link is really a 'copy-promotion-code' link, then exit early
        if ($(this).hasClass('copy-link')) {
            return;
        }

        // If this coupon-code has been applied already, then exit early
        if ($(this).hasClass('coupon-applied')) {
            return;
        }

        e.preventDefault();

        // Initialize local variables
        var couponCode;

        // Derive the coupon-code from the promotional content display
        couponCode = getCouponCode(this);

        // Attempt to apply the coupon-code to the cart
        applyCouponCode(this, couponCode, 'landing');

    });

    // Handle clicks on the copy-coupon-code link
    $('.pt_offerscoupons .copy-link').on('click', function(e) {

        e.preventDefault();

        // Initialize local variables
        var $couponPrefix;  // Represents the prefix-copy displayed before the coupon code
        var $this;          // Represents a jQUery instance of the action-link

        // jQuery-ify the current link
        $this = $(this);

        // Find the prefix element and replace it with the 'copied' label
        $couponPrefix = $this.find('.coupon-prefix');
        $couponPrefix.html(Resources.COUPON_CODE_COPIED);

        // Remove the href-attribute to copy-enable the link copy
        $this.removeAttr('href');

    });

    // Controls the closing of the image-overlay (error messaging)
    $('.pt_offerscoupons .oc-overlay-close').on('click', function(e) {

        e.preventDefault();

        // Initialize local variables
        var $imageOverlay;  // Represents the image overlay associated to this element

        // Find the parent image-overlay and hide it
        $imageOverlay = $(this).parent('.oc-image-overlay');
        $imageOverlay.hide();

    });

}

/**
 * @function initializeDetailUIEvents
 * @description Initializes the UI events necessary to drive the promotion-detail page behavior
 */
function initializeDetailUIEvents() {

    // Handle clicks on the apply-promotions link
    $('#promotionDetails .oc-apply-promo-link').on('click', function(e) {

        // If this coupon-code has been applied already, then exit early
        if ($(this).hasClass('coupon-applied')) {
            return;
        }

        e.preventDefault();

        // Initialize local variables
        var couponCode;     // Represents the derived coupon-code

        // Derive the coupon-code from the promotional content display
        couponCode = getCouponCode(this);

        // Attempt to apply the coupon-code to the cart
        applyCouponCode(this, couponCode, 'detail');

    });

}

/**
 * @function initializeLandingPage
 * @description Initializes the landing page and updates the coupon-code displays to render as applied (if applicable)
 */
function initializeLandingPage() {

    // Initialize local variables
    var $couponContent;     // Represents the collection of 'apply-links' present on the page
    var $applyLink;         // Represents the apply coupon-code link found within a couponContent element
    var $thisElement;       // Represents a jQuery instance of the couponContent content
    var couponCode;         // Describes the coupon-code being processed

    // If no coupon-codes are identified, then exit (nothing to process)
    if (window.ocapply.applied.length === 0) {
        return;
    }

    // Retrieve all of the coupon containers
    $couponContent = $('.pt_offerscoupons .oc-content-row');

    // Loop over each content row and
    $couponContent.each(function(arrayIndex, thisElement) {

        $thisElement = $(thisElement);

        // Parse out the current coupon-code to process
        couponCode = $thisElement.data('coupon');

        // If the page-rendered coupon-code in the collection of applied coupon-codes?
        if (window.ocapply.applied.indexOf(couponCode) !== -1) {

            // Find the apply-promotion link and determine if this is a copy-link
            $applyLink = $thisElement.find('.oc-apply-promo-link');
            if (!$applyLink.hasClass('copy-link')) {

                // If this is not a copy link, then disable the apply link
                // since the promotion has already been applied to the cart
                showSuccessMessage($applyLink);

            }

        }

    });

}

/**
 * @function applyCouponCode
 * @description Accepts a coupon-code, and attempts to apply the code to the user's cart
 * @param {Object} applyLink Represents the apply-link that was selected by the user
 * @param {String} couponCode Represents the coupon-code to be applied to the user's cart
 * @param {String} displayType Represents the display-type to render against (landing or detail)
 */
function applyCouponCode(applyLink, couponCode, displayType) {

    // Initialize local variables
    var url;                // Represents the url that will be submitted to
    var formValues;         // Represents the object containing the form values being posted

    // Get the URL for the form-submit
    url = window.Urls.applyCouponCode;

    // Init and seed the form-post values
    formValues = {};

    // Set the form properties necessary to submit the coupon-request
    formValues[window.ocapply.csrfTokenName] = window.ocapply.csrfTokenValue;
    formValues[window.ocapply.couponCodeName] = couponCode;
    formValues[window.ocapply.applyName] = 'submit';

    // Process the coupon
    ajax.load({
        method: 'post',
        url: url,
        data: formValues,
        callback: function (response) {

            // Parse the response
            var data = JSON.parse(response);

            // Was the coupon successfully applied?
            if (data.status === 'OK') {

                // If so, then show the landing-page success message
                showSuccessMessage(applyLink);

            } else {

                // Render different treatments depending on the page type
                if (displayType === 'landing') {

                    // Render the landing-page error treatment
                    showLandingCouponErrorTreatment(applyLink, data);

                } else {

                    // Render the detail-page error treatment
                    showDetailCouponErrorTreatment(data);

                }

            }

        }

    });

}

/**
 * @function showSuccessMessage
 * @description Updates an apply-link to include a success message
 * @param {Object} applyLink Represents the apply link invoked by the user
 */
function showSuccessMessage(applyLink) {

    // Initialize local variables
    var $applyLink;         // jQuery representation of the apply link

    // Create a reference to the apply link
    $applyLink = $(applyLink);

    // Show the code has been applied, and disable the apply-link for the future
    $applyLink.find('.coupon-prefix').html(Resources.COUPON_CODE_APPLIED);
    $applyLink.addClass('coupon-applied');
    $applyLink.removeAttr('href');

}

/**
 * @function showLandingCouponErrorTreatment
 * @description Updates a coupon treatment to display an error message to the user via the landing-page
 * @param {Object} applyLink Represents the apply link invoked by the user
 * @param {Object} dataObj Represents the return-result from the ajax-service containing the message to display
 */
function showLandingCouponErrorTreatment(applyLink, dataObj) {

    // Initialize local variables
    var $applyLink;         // jQuery representation of the apply link
    var $offerContent;      // Top-level parent for the offer container
    var $imageOverlay;      // Reference to the image-overlay container
    var $overlayMsg;        // Reference to the message-container

    // Create a reference to the apply-link
    $applyLink = $(applyLink);

    // Get the image-overlay by finding the top-level parent for this content-asset
    $offerContent = $applyLink.parents('.oc-offer-content');
    $imageOverlay = $offerContent.find('.oc-image-overlay');
    $overlayMsg = $imageOverlay.find('.oc-overlay-msg');

    // Render the error message
    $overlayMsg.html(dataObj.message);

    // Show the image overlay
    $imageOverlay.show();

}

/**
 * @function showDetailCouponErrorTreatment
 * @description Updates a coupon treatment to display an error message to the user via the promotion-details display
 * @param {Object} dataObj Represents the return-result from the ajax-service containing the message to display
 */
function showDetailCouponErrorTreatment(dataObj) {

    // Initialize local variables
    var $errorContainer;    // The mark-up element serving as the container for the error message
    var $errorMsg;          // The error message (where we will place the customer-facing text)

    // Get the image-overlay by finding the top-level parent for this content-asset
    $errorContainer = $('.promotion-details-dialog').find('.error-container');
    $errorMsg = $('.promotion-details-dialog').find('.oc-error-msg');

    // Render the error message
    $errorMsg.html(dataObj.message);

    // Show the error message (enable the centered formatting)
    $errorContainer.addClass('error-container-visible');
    $errorContainer.removeClass('error-container-hidden');
    $errorMsg.css('display', 'inline-block');


}


/**
 * @function getCouponCode
 * @description Retrieves the couponCode embedded in the parent link-element
 * @param {Object} linkElement Describes the anchor link for which the couponCode is derived
 * @returns {String} The couponCode embedded in the linkElement's parent
 */
function getCouponCode(linkElement) {

    // Initialize local variables
    var $couponContainer;   // Represents the parent <div> container that has the coupon-code attached as a data-element
    var couponCode;         // Represents the derived coupon-code (attached to the <div> via data-coupon)

    // Find the container and derive the coupon-code for the promotional
    // content element that was interacted with by the user
    $couponContainer = $(linkElement).parent('.oc-content-row');
    couponCode = $couponContainer.data('coupon');

    // Return the derived coupon-code
    return couponCode;

}

/**
 * @function setDialogTitle
 * @description Sets the title of the details-dialog by grabbing the title-content and placing it in the dialog titlebar
 */
function setDialogTitle() {

    // Initialize local variables
    var $dialogTitle;       // Reference to the dialog title-bar display-element
    var $dialogContent;     // Reference to the dialog-content container
    var $promotionContent;  // Reference to the promotion-content container
    var $promotionTitle;    // Reference to the promotion content tile display-element

    // Create a reference to the promotion content and parent dialog displays
    $promotionContent = $('#promotionDetails');
    $dialogContent = $('.' + PROMODETAILS_DIALOG_CLASSNAME);

    // Create references to each of the title elements in the dialog
    $dialogTitle = $dialogContent.find('.ui-dialog-title');
    $promotionTitle = $promotionContent.find('.oc-promo-title');

    // Copy the contents of the promotional content to the dialog title
    $dialogTitle.html($promotionTitle.html());
    $dialogTitle.show();

}

/**
 * @function showPromotionDetailsModal
 * @description Triggers the rendering of the promotion-details modal dialog
 * @param {String} couponCode Describes couponCode for which promotion-details are being rendered
 */
function showPromotionDetailsModal(couponCode, cid) {
    // Initialize local variables
    var modalUrl;
    var dialogWidth;
    var viewPortProperties;

    // Render the modal-url and append the couponCode parameter
    modalUrl = util.appendParamToURL(Urls.showPromotionDetails, 'couponCode', couponCode);
    modalUrl = util.appendParamToURL(modalUrl, 'cid', cid);

    // Derive the width of the modal dialog
    viewPortProperties = util.getViewPort();

    // Dynamically set the width of the dialog based on the viewPort
    if (viewPortProperties.viewPort === 'mobile') {
        dialogWidth = util.getViewPortWidth() * .8;
    } else {
        dialogWidth = '526px';
    }

    // Render the promotion-details dialog
    dialog.open({
        url: modalUrl,
        closeOnEscape: true,
        options: {

            dialogClass: PROMODETAILS_DIALOG_CLASSNAME,
            width: dialogWidth,
            open: function () {
                // Copy the promotion title to the title-bar when the dialog is opened
                setDialogTitle();

                // Close the promotion details dialog
                $('#promotionDetails .oc-promo-close-link').on('click', function(e){

                    e.preventDefault();
                    dialog.close();
                });
                /* PXSFCC-4495_WCAG_Modal_focus_management */
            	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
                	$(this).focus();
                });
                $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
            }
        }
    });
}

exports.init = function() {

    // Initialize the UI events for this page
    initializeLandingUIEvents();

    // Initialize the page rendering
    initializeLandingPage();

    // Initialize the offer-coupon namespace
    window.ocapplyAPI = {};

    // Expose the initDetailUIEvents function for the details-display
    window.ocapplyAPI.initializeDetailUIEvents = initializeDetailUIEvents;

};
